
  // Focuses the dialog's first control when it opens, as JS.focus_first did,
  // but never takes focus back from a control inside the dialog.
  // JS.focus_first focuses at once and AGAIN two animation frames later
  // (LiveView's js.js, exec_focus_first). On a starved CI runner that second
  // focus landed after Wallaby had moved into a field and started typing:
  // focus jumped to the close button and the next space pressed it (J41, J42,
  // J77, J78 in docs/CI_TEST_FAILURES.md). The retry stays for the case it
  // exists for, a dialog not yet focusable at mount, and is skipped once focus
  // is already inside. The focusability rules mirror LiveView's aria.js.
  export default {
    mounted() {
      this.focusFirst();
      requestAnimationFrame(() => requestAnimationFrame(() => {
        if (this.el.isConnected && !this.el.contains(document.activeElement)) {
          this.focusFirst();
        }
      }));
    },
    focusFirst() {
      return this.focusFirstIn(this.el, true) || this.focusFirstIn(this.el, false);
    },
    focusFirstIn(el, interactiveOnly) {
      for (let child = el.firstElementChild; child; child = child.nextElementSibling) {
        if (this.attemptFocus(child, interactiveOnly) || this.focusFirstIn(child, interactiveOnly)) {
          return true;
        }
      }
      return false;
    },
    attemptFocus(el, interactiveOnly) {
      const visible = el.getAttribute("aria-hidden") !== "true";
      const focusable =
        (el instanceof HTMLAnchorElement && el.rel !== "ignore") ||
        (el instanceof HTMLAreaElement && el.href !== undefined) ||
        (!el.disabled &&
          [HTMLInputElement, HTMLSelectElement, HTMLTextAreaElement, HTMLButtonElement]
            .some((type) => el instanceof type)) ||
        el instanceof HTMLIFrameElement ||
        (el.tabIndex >= 0 && visible) ||
        (!interactiveOnly && el.getAttribute("tabindex") !== null && visible);
      if (focusable) {
        try { el.focus(); } catch (_error) { /* as aria.js: not focusable after all */ }
      }
      return document.activeElement === el;
    }
  }
